import React from 'react'
import { BadgeVariant, Flex, Modal, StatusBadge } from '@mprolab/uikit'
import { useTranslation } from 'react-i18next'

interface ConfirmTransactrionModalProps {
  onDismiss?: () => void
}

const ConfirmTransactionModal: React.FC<ConfirmTransactrionModalProps> = ({ onDismiss }) => {
  const { t } = useTranslation()
  return (
    <Modal title={t('modal.confirmTransaction')} hideCloseButton {...{ onDismiss }}>
      <Flex width="100%" alignItems="center" justifyContent="center" pt="32px">
        <StatusBadge title={t('modal.continueInWallet')} variant={BadgeVariant.PENDING} />
      </Flex>
    </Modal>
  )
}

export default ConfirmTransactionModal
